export const MAXIMUM_EMAIL_INVITE_SEAT = 50;

export const SEAT_STEPS = {
     ASSIGN_MULTIPLE_SEAT: 'Assign Multiple Users to Seats',
     SEAT_ASSIGNMENT_COMPLETE: 'Seat Assignment Complete',
};
